import React from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import SVGImage from '../layout/SVGImage';

interface DropdownProps {
  className?: string;
  testId?: string;
  itemTestId?: string;
  selectedItem?: string;
  items: Array<string>;
  onSelected: (text: string) => void;
  disabled?: boolean;
  name?: string;
}

const Dropdown: React.FC<DropdownProps> = ({
  testId,
  itemTestId,
  items,
  className,
  selectedItem,
  onSelected,
  disabled = false,
  name,
}) => {
  return (
    <Menu as="div" className={`${className} relative inline-block text-left`}>
      <div data-testid={testId}>
        <MenuButton
          className={`inline-flex w-full items-center justify-between gap-x-1.5 rounded-[5px] pb-[13px] ${disabled ? 'cursor-not-allowed text-[#98A2AB]' : 'text-dark-3'}`}
          disabled={disabled}
        >
          {selectedItem}
          <SVGImage aria-hidden="true" name="chevron-down" />
        </MenuButton>
      </div>

      <MenuItems
        transition
        className="absolute right-0 z-10 mt-1 max-h-[150px] w-full overflow-scroll rounded-[5px] bg-white shadow-2 ring-1 ring-[#D1DBDA] transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <div className="py-[10px]">
          {items.map((text, index) => (
            <MenuItem key={index}>
              <p
                data-testid={itemTestId}
                onClick={() => onSelected(text)}
                className="pop-13-normal block cursor-pointer px-[19px] py-2 text-dark-10 data-[focus]:bg-light-3 data-[focus]:bg-opacity-60 data-[focus]:text-dark-4 data-[focus]:outline-none"
              >
                {text}
              </p>
            </MenuItem>
          ))}
        </div>
      </MenuItems>
      <input type="hidden" name={name} value={selectedItem} />
    </Menu>
  );
};

export default Dropdown;
